import { render, staticRenderFns } from "./SelectGroupQuantities.vue?vue&type=template&id=72ec3ec6&"
import script from "./SelectGroupQuantities.vue?vue&type=script&lang=ts&"
export * from "./SelectGroupQuantities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports